import apiClient from './client';

export interface TierChangePreview {
  current_tier: string;
  new_tier: string;
  current_price: number;
  new_price: number;
  days_remaining: number;
  remaining_value: number;
  new_duration: number;
  new_expires_at: string;
  charge_amount: number;
  is_upgrade: boolean;
  current_expires_at?: string;
  trial_days_granted: number;
}

export interface PreviewTierChangeRequest {
  new_tier: string;
}

export interface ConfirmTierChangeRequest {
  preview: TierChangePreview;
}

export const tierChangeApi = {
  /**
   * Get preview of tier change with recalculation
   */
  preview: async (organizationId: string, newTier: string): Promise<TierChangePreview> => {
    const response = await apiClient.post<TierChangePreview>(
      `/organizations/${organizationId}/tier-change/preview`,
      { new_tier: newTier } as PreviewTierChangeRequest
    );
    return response.data;
  },

  /**
   * Confirm and apply tier change
   */
  confirm: async (organizationId: string, preview: TierChangePreview): Promise<void> => {
    await apiClient.post(
      `/organizations/${organizationId}/tier-change/confirm`,
      { preview } as ConfirmTierChangeRequest
    );
  },
};
